import React from "react";

import State from "../../../../containers/State";
import { ReactComponent as StateIcon } from "../../../../img/icons/Puntarenas.svg";
import { CAMPAIGN_2024 } from '../../../../constants';

const stateName = "Puntarenas";
const stateId = "jcSpufUDvvvVbK5v30e6";

const Puntarenas = () => {
  return (
    <State stateName={stateName} stateId={stateId} Icon={StateIcon} year="2024" campaign={CAMPAIGN_2024}> 
      <StateIcon />
    </State>
  );
};

export default Puntarenas;
